import { defaultDateDef } from '@components/_SiteWide/CellTemplates/typeColumnDefs'
import { InfoIcon } from '@components/_SiteWide/InfoIcon'
import { OpenDrawerButton } from '@components/_SiteWide/OpenDrawerButton'
import { ResponseDrawer } from '@components/DriverManagement/DriverForms/components/ResponseDrawer'
import { BBDTag, GraviButton, Horizontal, Texto } from '@gravitate-js/excalibrr'
import { sortStringNumbers } from '@utils/general'
import { getStoreNumberComparator } from '@utils/grid'
import { Button } from 'antd'
import React from 'react'

const responseCellRenderer = (params, setDrawerPayload) => {
  if (params.node.group) return null
  return <OpenDrawerButton onClick={() => setDrawerPayload({ ...params.data, visible: true })} />
}

export const getColumnDefs = (formatDecimal, setDrawerPayload) => {
  return [
    {
      headerName: 'Form Name',
      field: 'name',
      enableRowGroup: true,
    },
    {
      headerName: 'Order Number',
      enableRowGroup: false,
      field: 'order_number',
    },
    {
      headerName: 'Date',
      field: 'date',
      ...defaultDateDef('date'),
    },
    {
      headerName: 'Driver Name',
      field: 'driver_name',
    },
    {
      headerName: 'Shift',
      field: 'shift',
      valueFormatter: (params) => params.value?.toUpperCase(),
    },
    {
      headerName: 'Location',
      field: 'location_name',
      comparator: getStoreNumberComparator('location_name'),
    },
    {
      headerName: 'Address',
      field: 'address',
    },
    {
      headerName: 'Lat.',
      field: 'latitude',
      enableRowGroup: false,
      initialHide: true,
      valueFormatter: (params) => (!params.node.group ? formatDecimal(params?.value, 5) : null),
      filter: 'agNumberColumnFilter',
    },
    {
      headerName: 'Lon.',
      field: 'longitude',
      enableRowGroup: false,
      initialHide: true,
      valueFormatter: (params) => (!params.node.group ? formatDecimal(params?.value, 5) : null),
      filter: 'agNumberColumnFilter',
    },
    {
      headerName: 'Market',
      field: 'market',
    },
    {
      headerName: 'Sector',
      field: 'sector',
    },
    {
      headerName: 'Supply Zone',
      field: 'supply_zone',
    },
    {
      headerName: 'State',
      field: 'state',
    },
    {
      headerName: 'Tractor',
      field: 'tractor',
      comparator: getStoreNumberComparator('tractor'),
    },
    {
      headerName: 'Trailer',
      field: 'trailer_number',
      comparator: getStoreNumberComparator('trailer_number'),
    },
    {
      headerName: 'Required',
      headerTooltip: 'Whether the form was required by the location or optional',
      field: 'required',
      valueFormatter: (params) => (!params.node.group ? (params.value ? 'True' : 'False') : null),
      cellRenderer: 'agTextCellRenderer',
    },
    {
      headerName: 'Response',
      excludeFromExport: true,
      cellRenderer: (params) => responseCellRenderer(params, setDrawerPayload),
    },
  ]
}
